@if (loading && stages.length === 0) {
<section class="dashboard-funnel dashboard-funnel--skeleton" aria-label="Loading request fulfillment funnel">
  <div class="dashboard-funnel__header">
    <div class="dashboard-funnel__skeleton-line dashboard-funnel__skeleton-line--title"></div>
    <div class="dashboard-funnel__skeleton-line dashboard-funnel__skeleton-line--meta"></div>
  </div>
  <div class="dashboard-funnel__skeleton-track">
    @for (stage of getSkeletonFunnelStages(); track stage) {
    <div class="dashboard-funnel__skeleton-node"></div>
    }
  </div>
</section>
} @else if (stages.length > 0) {
<section class="dashboard-funnel" aria-label="Request fulfillment funnel">
  <div class="dashboard-funnel__header">
    <div>
      <h2 class="dashboard-funnel__title">Request Fulfillment Funnel</h2>
      <p class="dashboard-funnel__subtitle">
        Shows how many requests move from creation to packing, shipping, delivery, and submitted testimony for {{ selectedPeriodLabel
        }}.
      </p>
    </div>
  </div>

  <div class="dashboard-funnel__chart" role="img" aria-label="Request fulfillment funnel chart">
    <svg class="dashboard-funnel__svg" viewBox="0 0 920 410" preserveAspectRatio="xMidYMid meet">
      <defs>
        <linearGradient id="dashboardFunnelFill" x1="0%" x2="100%" y1="0%" y2="0%">
          <stop offset="0%" stop-color="#19a7f2"></stop>
          <stop offset="58%" stop-color="#57b7ee"></stop>
          <stop offset="100%" stop-color="#9bd0f4"></stop>
        </linearGradient>
      </defs>

      <g class="dashboard-funnel__grid" aria-hidden="true">
        @for (boundary of getFunnelBoundaryIndexes(); track boundary) {
        <line [attr.x1]="getFunnelBoundaryX(boundary)" y1="24" [attr.x2]="getFunnelBoundaryX(boundary)" y2="386"></line>
        }
      </g>

      <g class="dashboard-funnel__labels">
        @for (stage of stages; track stage.key; let stageIndex = $index) {
        <text class="dashboard-funnel__stage-label" [attr.x]="getFunnelSegmentLabelX(stageIndex)" y="38">
          @for (line of getFunnelLabelLines(stage.title); track line; let lineIndex = $index) {
          <tspan [attr.x]="getFunnelSegmentLabelX(stageIndex)" [attr.dy]="lineIndex === 0 ? 0 : 15">{{ line }}</tspan>
          }
        </text>
        }
      </g>

      <path class="dashboard-funnel__shape" [attr.d]="getFunnelPath()"></path>

      <g class="dashboard-funnel__metrics">
        @for (stage of stages; track stage.key; let stageIndex = $index) {
        <text [attr.x]="getFunnelSegmentMetricX(stageIndex)" y="362">
          <tspan class="dashboard-funnel__metric-percent" [attr.x]="getFunnelSegmentMetricX(stageIndex)">
            {{ formatFunnelPercentage(stage.percentageOfBase) }}
          </tspan>
          <tspan class="dashboard-funnel__metric-value" [attr.x]="getFunnelSegmentMetricValueX(stageIndex, stage)" dy="22">
            {{ formatValue(stage.value) }}
          </tspan>
        </text>
        }
      </g>
    </svg>
  </div>
</section>
}
